// AdminCouponCreate.jsx
import React, { useState } from 'react';
import '../styles/AdminCouponCreate.css';
import AdminSidebar from "./AdminSidebar";
import { toast } from "../../utils/toast";
import { adminFetch } from "../../api/adminFetch";

const AdminCouponCreate = () => {
    const [form, setForm] = useState({
        name: '',
        discountType: 'FIXED',
        discountValue: '',
        minPurchase: '',
        quantity: '',
        startDate: '',
        endDate: '',
        couponCode: '',
        isActive: true
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const res = await adminFetch('/api/admin/coupons/create', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form)
        });

        if (res.ok) {
            toast("✅ 쿠폰이 성공적으로 생성되었습니다.");
            setForm({
                name: '',
                discountType: 'FIXED',
                discountValue: '',
                minPurchase: '',
                quantity: '',
                startDate: '',
                endDate: '',
                couponCode: '',
                isActive: true
            });
        } else {
            toast("❌ 쿠폰 생성에 실패했습니다.");
        }
    };

    return (
        <div className="coupon-create-container">
            <h2>쿠폰 생성</h2>
            <AdminSidebar />
            <form onSubmit={handleSubmit} className="coupon-form">
                <label>쿠폰 이름:
                    <input type="text" name="name" value={form.name} onChange={handleChange} required />
                </label>

                <label>할인 방식:
                    <select name="discountType" value={form.discountType} onChange={handleChange}>
                        <option value="FIXED">정액 할인</option>
                        <option value="PERCENT">정률 할인</option>
                    </select>
                </label>

                <label>할인 금액 / 비율:
                    <input type="number" name="discountValue" value={form.discountValue} onChange={handleChange} required />
                </label>

                <label>최소 결제 금액:
                    <input type="number" name="minPurchase" value={form.minPurchase} onChange={handleChange} />
                </label>

                <label>발급 수량:
                    <input type="number" name="quantity" value={form.quantity} onChange={handleChange} required />
                </label>

                <label>시작일:
                    <input type="date" name="startDate" value={form.startDate} onChange={handleChange} required />
                </label>

                <label>종료일:
                    <input type="date" name="endDate" value={form.endDate} onChange={handleChange} required />
                </label>

                <label>쿠폰 코드 (선택):
                    <input type="text" name="couponCode" value={form.couponCode} onChange={handleChange} />
                </label>

                <label className="coupon-available-checkbox">
                    <input type="checkbox" name="isActive" checked={form.isActive} onChange={handleChange} />
                    사용 가능 상태
                </label>

                <button type="submit" className="create-btn">쿠폰 생성</button>
            </form>
        </div>
    );
};

export default AdminCouponCreate;
